import { Modal, ModalTabs, OfficeButton, PromotionAuditView, PromotionView, Show } from "components";
import {
  UpdatePromotionStatus,
  UpdatePromotionStatusVariables,
} from "_graphql/mutation/__generated__/UpdatePromotionStatus";
import { useCallback, useState } from "react";
import { useNavigate, useSearch } from "react-location";

import { LocationGenerics } from "router/location";
import { PromotionStatus } from "_graphql/__generated__/globalTypes";
import toast from "react-hot-toast";
import { updatePromotionStatus } from "_graphql/visal/mutations/promotions";
import { useClassOfBusiness } from "hooks/data/use-class-of-business";
import { useMutation } from "@apollo/client";
import { usePromotion } from "hooks/data/use-promotions";
import { useUrlState } from "utils";

const tabs = [
  { name: "Details", href: "Details" },
  { name: "Performance", href: "Performance" },
  { name: "Audit trail", href: "Audit" },
];

export default function ViewContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const [orderStatus, setOrderStatus] = useState("Details");
  const searchParams = useSearch<LocationGenerics>();
  const { loading, promotion } = usePromotion({
    getPromotionId: searchParams.id || "",
  });

  const [execute, { loading: updating }] = useMutation<
    UpdatePromotionStatus,
    UpdatePromotionStatusVariables
  >(updatePromotionStatus, {
    refetchQueries: ["GetPromotions", "GetPromotion"],
  });

  const toggleStatus = useCallback((status: PromotionStatus) => {
    execute({
      variables: {
        input: {
          id: searchParams.id || "",
          status,
        },
      },
    })
      .then(({ data }) => {
        if (data?.updatePromotionStatus)
          toast.success("Promotion status updated successfully");
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to update promotion status");
      });
  }, []);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Promotion Information"
      description="Details of promotion are shown below"
      hidePadding
      renderActions={() => (
        <div className="flex space-x-2">
          <OfficeButton
            size="sm"
            onClick={() => {
              toggleStatus(
                promotion?.status === PromotionStatus.ACTIVE
                  ? PromotionStatus.INACTIVE
                  : PromotionStatus.ACTIVE
              );
            }}
            loading={updating}
            disabled={updating}
            variant={
              promotion?.status === PromotionStatus.ACTIVE
                ? "danger"
                : "primary"
            }
          >
            {promotion?.status === PromotionStatus.ACTIVE
              ? "Disable Promotion"
              : "Enable Promotion"}
          </OfficeButton>
        </div>
      )}
    >
      <ModalTabs tabs={tabs} orderStatus={orderStatus} setOrderStatus={setOrderStatus} />
      <div className="p-4">
        <Show if={orderStatus === "Details"}>
          <PromotionView promotion={promotion} />
        </Show>
        <Show if={orderStatus === "Audit"}>
          <PromotionAuditView promotion={promotion} />
        </Show>
      </div>
    </Modal>
  );
}
